export function validatePassword(newPassword: string): string[] {
    let errors: string[] = [];

    var regexpUpper = new RegExp('[A-Z]');
    var regexpLower = new RegExp('[a-z]');
    var regexpNumber = new RegExp('[0-9]');
    var regexpSpecial = new RegExp('[^A-Za-z0-9]');

    if (newPassword.length < 10) {
        errors = ([...errors, "Passwords must be at least 10 characters long"]);
    }
    let matches = 0;
    if (regexpUpper.test(newPassword)) {
        matches++;
    }
    if (regexpLower.test(newPassword)) {
        matches++;
    }
    if (regexpSpecial.test(newPassword)) {
        matches++;
    }
    if (regexpNumber.test(newPassword)) {
        matches++;
    }
    if (matches < 3) {
        errors = ([...errors, "Passwords must contain at least 3 of the following types: a lowercase letter, an uppercase letter, a number or a special character. Valid characters are: ! # £ $ % & * . , \" ` @ ^ = + - _ ? ~"]);
    }
    return errors;
}